import {AppCombineReducers} from './combineReducer';

import {configureStore} from '@reduxjs/toolkit';

export const appStore = configureStore({
  reducer: AppCombineReducers,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
  devTools: import.meta.env.VITE_ENVIRONMENT !== 'prod',
});
